import cookiesConsentStyles from './cookies-consent';

var cookieConsentBar = document.querySelector('.cookie-bar');
if(cookieConsentBar){
  var cookieConsentBarHolder = document.querySelector('div.cookies-consent-component');
  var cookieName = "pods-cookieConsentBar-" + cookieConsentBar.getAttribute('data-alertid');
  var cookieIsDismissed = (cookies.getCookie(cookieName) ? cookies.getCookie(cookieName) : null);
  if (cookieIsDismissed == "true") {
    cookieConsentBarHolder.classList.add('dismissed')
  }
  attachClickEvent();
  function setCookies() {
    cookies.setCookie(`pods-cookieConsentBar-${cookieConsentBar.getAttribute('data-alertid')}`, !0, 365)
  }
  function attachClickEvent() {
    document.querySelector('.cookie-bar__closer').addEventListener("click", (e) => { setCookies(); cookieConsentBarHolder.classList.add('dismissed') })
  }
}
